#import "../fragments/sales-automation-stageset.graphql"

mutation UpdateDefaultStagesetForOnboardingWizard(
    $optionSelections: UpdateDefaultStagesetForOnboardingWizardInputFieldInput!
) {
    updateDefaultStagesetForOnboardingWizard(input: {responses: $optionSelections}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
